import { render } from "./ModalList.vue?vue&type=template&id=73ffaa52&scoped=true"
import script from "./ModalList.vue?vue&type=script&lang=js"
export * from "./ModalList.vue?vue&type=script&lang=js"

import "./ModalList.vue?vue&type=style&index=0&id=73ffaa52&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-73ffaa52"

export default script